import { useQueryClient } from 'react-query';

import { useCustomSnackBar } from 'hooks/useCustomSnackBar';

export const useStatusCellLogic = ({ api, riskId }: { api: any; riskId: number }) => {
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const updateStatus = (value) => {
        api.updateRiskProperty.instance.mutate(
            {
                id: riskId,
                status: value.name,
            },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries('getRiskRegister').then(() => {
                        handleSnackBar('Risk register updated successfully', 'success');
                    });
                },
                onError: () => {
                    handleSnackBar('Failed to update risk register', 'error');
                },
            },
        );
    };
    return { logic: { updateStatus } };
};
